import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setDisplayLoader } from '@/redux/app/appSlice';
import {
  setAddMessageStatus,
  setCountUnreadMessages,
  setCreatedTicketStatus,
  setDialog,
  setTicket,
  setTickets,
  setTicketTopics,
} from '@/redux/support/supportSlice';

import supportService from '@/services/supportService';

const getTickets = () => async dispatch => {
  try {
    dispatch(setDisplayLoader(true));

    const data = await supportService.getTickets();

    dispatch(setTickets(data));
  } catch (e) {
    Notify.failure(
      e?.response?.data?.message ||
        e?.response?.data?.error ||
        'Request GetTickets failure',
    );
  } finally {
    dispatch(setDisplayLoader(false));
  }
};

const getTicketTopics = () => async dispatch => {
  try {
    dispatch(setDisplayLoader(true));

    const data = await supportService.getTicketTopics();

    dispatch(setTicketTopics(data));
  } catch (e) {
    Notify.failure(
      e?.response?.data?.message ||
        e?.response?.data?.error ||
        'Request GetTicketTopics failure',
    );
  } finally {
    dispatch(setDisplayLoader(false));
  }
};

const addTicket =
  ({ topic_id, title, message, files }) =>
  async dispatch => {
    try {
      dispatch(setDisplayLoader(true));

      const formData = new FormData();
      formData.append('ticket_topic_id', topic_id);
      formData.append('title', title);
      formData.append('message', message);
      files.forEach(file => {
        formData.append('files[]', file);
      });

      await supportService.addTicket(formData);

      dispatch(setCreatedTicketStatus('success'));

      dispatch(getTickets());
    } catch (e) {
      if (e?.response?.status === 422) {
        dispatch(
          setCreatedTicketStatus(
            e?.response?.data?.message || e?.response?.data?.error,
          ),
        );
        return;
      }

      Notify.failure(
        e?.response?.data?.message ||
          e?.response?.data?.error ||
          'Request AddTicket failure',
      );
    } finally {
      dispatch(setDisplayLoader(false));
    }
  };

const getTicket = id => async dispatch => {
  try {
    const data = await supportService.getTicket(id);
    const { messages, ...rest } = data;

    dispatch(setTicket({ ...rest }));
    dispatch(setDialog(messages));
  } catch (e) {
    Notify.failure(
      e?.response?.data?.message ||
        e?.response?.data?.error ||
        'Request GetTicket failure',
    );
  }
};

const addMessage =
  ({ id, message, files }) =>
  async dispatch => {
    try {
      dispatch(setDisplayLoader(true));

      const formData = new FormData();
      formData.append('message', message);
      files.forEach(file => {
        formData.append('files[]', file);
      });

      await supportService.addMessage({ id, formData });

      dispatch(setAddMessageStatus('success'));

      const data = await supportService.getTicket(id);

      dispatch(setDialog(data.messages));
    } catch (e) {
      Notify.failure(
        e?.response?.data?.message ||
          e?.response?.data?.error ||
          'Request AddMessage failure',
      );
    } finally {
      dispatch(setDisplayLoader(false));
    }
  };

const getUnreadTickets = () => async dispatch => {
  try {
    const data = await supportService.getUnreadTickets();

    dispatch(setCountUnreadMessages(data?.count));
  } catch (e) {
    console.error(e);
    // Notify.failure(e?.response?.data?.message || e?.response?.data?.error || 'Request GetUnreadTickets failure')
  }
};

export default {
  getTickets,
  getTicketTopics,
  addTicket,
  getTicket,
  addMessage,
  getUnreadTickets,
};
